import React from "react";
import { Stack, TextField } from "@mui/material";

const ReadOnlyTextField = ({ label, value, onChange, isEnglish = false }) => {
  React.useEffect(() => {
    onChange && onChange(value);
  }, [value]);
  return (
    <React.Fragment>
      <Stack alignItems="flex-end" width="100%">
        <sub
          style={{
            width: "100%",
            textAlign: isEnglish ? "left" : "right",
          }}
          dir={isEnglish ? "ltr" : "rtl"}
        >
          {label}
        </sub>
        <TextField
          fullWidth
          color="colorPrimer"
          disabled
          value={value === "" ? "داده ای ثبت نشده" : value ?? ""}
          size="small"
        />
      </Stack>
    </React.Fragment>
  );
};

export default ReadOnlyTextField;
